import React from "react";
import { Line } from "rc-progress";
const LoadedMedia = (props) => {
    const { url, progress } = props;
    return (React.createElement("div", { className: 'loaded-media__container' },
        React.createElement("div", { className: 'loaded-media__image-box' },
            React.createElement("img", { src: url }),
            progress < 100 && (React.createElement(React.Fragment, null,
                React.createElement("div", { className: 'loaded-media__image-progress-overlay' }),
                React.createElement("div", { className: 'loaded-media__image-progress' },
                    React.createElement(Line, { percent: progress, strokeWidth: 4, trailWidth: 3, strokeColor: "#008DFF" })))))));
};
export default LoadedMedia;
